/**
 * Sidebar entries an administrator can hide per agent, in menu order. Names
 * mirror the items in Sidebar.vue; a child key joins the parent with "/", so a
 * name reused at different levels (Settings) stays unambiguous. Dynamic
 * entries such as each inbox or team are not listed: they follow the agent's
 * membership.
 */
export const sidebarItemKey = (name, parentKey = '') =>
  parentKey ? `${parentKey}/${name}` : name;

export const HIDEABLE_SIDEBAR_ITEMS = Object.freeze([
  { name: 'Inbox', label: 'SIDEBAR.INBOX' },
  {
    name: 'Conversation',
    label: 'SIDEBAR.CONVERSATIONS',
    children: [
      { name: 'All', label: 'SIDEBAR.ALL_CONVERSATIONS' },
      { name: 'Mentions', label: 'SIDEBAR.MENTIONED_CONVERSATIONS' },
      { name: 'Participating', label: 'SIDEBAR.PARTICIPATING_CONVERSATIONS' },
      { name: 'Unattended', label: 'SIDEBAR.UNATTENDED_CONVERSATIONS' },
      { name: 'Folders', label: 'SIDEBAR.CUSTOM_VIEWS_FOLDER' },
      { name: 'Teams', label: 'SIDEBAR.TEAMS' },
      { name: 'Channels', label: 'SIDEBAR.CHANNELS' },
      { name: 'Labels', label: 'SIDEBAR.LABELS' },
    ],
  },
  {
    name: 'Captain',
    label: 'SIDEBAR.CAPTAIN',
    children: [
      { name: 'Overview', label: 'SIDEBAR.CAPTAIN_OVERVIEW' },
      { name: 'FAQs', label: 'SIDEBAR.CAPTAIN_RESPONSES' },
      { name: 'Documents', label: 'SIDEBAR.CAPTAIN_DOCUMENTS' },
      { name: 'Scenarios', label: 'SIDEBAR.CAPTAIN_SCENARIOS' },
      { name: 'Playground', label: 'SIDEBAR.CAPTAIN_PLAYGROUND' },
      { name: 'Inboxes', label: 'SIDEBAR.CAPTAIN_INBOXES' },
      { name: 'Tools', label: 'SIDEBAR.CAPTAIN_TOOLS' },
      { name: 'Settings', label: 'SIDEBAR.CAPTAIN_SETTINGS' },
    ],
  },
  { name: 'Calls', label: 'SIDEBAR.CALLS' },
  {
    name: 'Contacts',
    label: 'SIDEBAR.CONTACTS',
    children: [
      { name: 'All Contacts', label: 'SIDEBAR.ALL_CONTACTS' },
      { name: 'Active', label: 'SIDEBAR.ACTIVE' },
      { name: 'Segments', label: 'SIDEBAR.CUSTOM_VIEWS_SEGMENTS' },
      { name: 'Tagged With', label: 'SIDEBAR.TAGGED_WITH' },
    ],
  },
  {
    name: 'Companies',
    label: 'SIDEBAR.COMPANIES',
    children: [{ name: 'All Companies', label: 'SIDEBAR.ALL_COMPANIES' }],
  },
  {
    name: 'Reports',
    label: 'SIDEBAR.REPORTS',
    children: [
      { name: 'Report Overview', label: 'SIDEBAR.REPORTS_OVERVIEW' },
      { name: 'Report Conversation', label: 'SIDEBAR.REPORTS_CONVERSATION' },
      { name: 'Reports Agent', label: 'SIDEBAR.REPORTS_AGENT' },
      { name: 'Reports Label', label: 'SIDEBAR.REPORTS_LABEL' },
      { name: 'Reports Inbox', label: 'SIDEBAR.REPORTS_INBOX' },
      { name: 'Reports Team', label: 'SIDEBAR.REPORTS_TEAM' },
      { name: 'Reports CSAT', label: 'SIDEBAR.CSAT' },
      { name: 'Reports SLA', label: 'SIDEBAR.REPORTS_SLA' },
      { name: 'Reports Bot', label: 'SIDEBAR.REPORTS_BOT' },
    ],
  },
  {
    name: 'Campaigns',
    label: 'SIDEBAR.CAMPAIGNS',
    children: [
      { name: 'Live chat', label: 'SIDEBAR.LIVE_CHAT' },
      { name: 'SMS', label: 'SIDEBAR.SMS' },
      { name: 'WhatsApp', label: 'SIDEBAR.WHATSAPP' },
    ],
  },
  {
    name: 'Portals',
    label: 'SIDEBAR.HELP_CENTER.TITLE',
    children: [
      { name: 'Articles', label: 'SIDEBAR.HELP_CENTER.ARTICLES' },
      { name: 'Categories', label: 'SIDEBAR.HELP_CENTER.CATEGORIES' },
      { name: 'Locales', label: 'SIDEBAR.HELP_CENTER.LOCALES' },
      { name: 'Settings', label: 'SIDEBAR.HELP_CENTER.SETTINGS' },
    ],
  },
  { name: 'Settings', label: 'SIDEBAR.SETTINGS' },
]);
